import { createContext, useContext, useEffect, useState } from "react";
import apiRequest from "../lib/apiRequest";
import encryptedapiRequest from "../lib/encryptedapiRequest";

const ColoniesContext = createContext();

export const ColoniesProvider = ({ children }) => {
  const [colonies, setColonies] = useState([]); 
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let isMounted = true;

    encryptedapiRequest.get("/masters/colonies")
      .then((response) => {
        if (isMounted) {
          setColonies(response.data || []);
          setReady(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching colonies:", error);
        if (isMounted) {
          setColonies([]);
          setReady(true);
        }
      });

    return () => { isMounted = false };
  }, []);

  return (
    <ColoniesContext.Provider value={{ colonies, ready }}>
      {children}
    </ColoniesContext.Provider>
  );
};

export const useColonies = () => useContext(ColoniesContext);
